
import Vue from 'vue';
import Vuex from 'vuex';

// import store modules here
import shell from 'frontend/shell/store';
import addresses from 'frontend/addresses/store';
import paymentMethods from 'frontend/payment-methods/store';
import customizer from 'frontend/customize/store';
import cart from 'frontend/cart/store';
import checkout from 'frontend/checkout/store';
import profile from 'frontend/profile/store';

Vue.use(Vuex);
// Vue.config.devtools = true;

export default new Vuex.Store({
	modules: {
		shell, addresses, paymentMethods, customizer, cart, checkout, profile,
	}
})